import { Injectable, signal } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { PrismDialogRef } from '@shure/prism-angular-components';
import { FooterButtonsConfig, StepConfig } from '@shure/shared/angular/ui/components/step-router';

import { AddDevicesDialogComponent } from '../add-devices-dialog.component';

import { Step1HowToFindComponent } from './step1-how-to-find.component';

@Injectable()
export class Step1HowToFindConfig implements StepConfig {
	public readonly isValid = signal(false);

	public readonly id = 'step1-how-to-find';
	public readonly label = this.transloco.translate('cloud.add-devices-dialog.choose-method');
	public readonly component = signal(Step1HowToFindComponent);
	public readonly footerButtons = signal<FooterButtonsConfig>({
		left: [
			{
				text: this.transloco.translate('cloud.shared.button-text.cancel'),
				id: 'sh-add-devices-step1-cancel',
				testId: 'step1-cancel-button',
				onClick: (): void => {
					this.dialogRef.close();
				}
			}
		],
		right: [
			{
				text: this.transloco.translate('cloud.shared.button-text.next'),
				id: 'sh-add-devices-step1-next',
				testId: 'step1-next-button',
				isEnabled: this.isValid,
				onClick: (stepRouter): void => {
					stepRouter.nextStep();
				}
			}
		]
	});

	constructor(
		private readonly transloco: TranslocoService,
		private readonly dialogRef: PrismDialogRef<AddDevicesDialogComponent>
	) {}
}
